export default __webpack_public_path__ + "images/FLYSAFARI.b749650.png";